import React from 'react';
import { Outlet } from 'react-router-dom';
import { DomiraHeader } from '../components/layout/DomiraHeader';
import { DomiraFooter } from '../components/layout/DomiraFooter';
import { useLanguage } from '../context/LanguageContext';

export function DomiraLayout() {
  const { lang } = useLanguage();
  return (
    <div className="flex min-h-screen flex-col bg-paelbi-bg">
      <DomiraHeader />
      <main key={lang} className="flex-1">
        <Outlet />
      </main>
      <DomiraFooter />
    </div>
  );
}

export default DomiraLayout;
